function PredictiveSearch() {
    const searchInputDesktop = document.querySelector(".search-input");
    const predictiveSearchDesktop = document.querySelector(".predictive-search");
    const clearSearchDesktop = document.querySelector(".search-clear");
    const searchButtonDesktop = document.getElementById("search_button");
    const searchSectionDesktop = document.querySelector(".p-search-section");

    const searchInputMobile = document.querySelector(".search-input-mobile");
    const predictiveSearchMobile = document.querySelector(".predictive-search-mobile");
    const clearSearchMobile = document.querySelector(".search-clear-mobile");
    const searchButtonMobile = document.getElementById("m_search_button");
    const searchSectionMobile = document.querySelector(".p-search-section-mobile");

    const headerMenu = document.querySelector(".header-menu");
    let activeInput = null;

    const loadingSkeletonLTR = `
        <div class="product"><div class="avatar"></div><div class="line"></div><div class="line"></div></div>
        <div class="product"><div class="avatar"></div><div class="line"></div><div class="line"></div></div>
        <div class="product"><div class="avatar"></div><div class="line"></div><div class="line"></div></div>
        <div class="product"><div class="avatar"></div><div class="line"></div><div class="line"></div></div>
    `;
    const loadingSkeletonRTL = `
        <div class="product"><div class="line"></div><div class="line"></div><div class="avatar"></div></div>
        <div class="product"><div class="line"></div><div class="line"></div><div class="avatar"></div></div>
        <div class="product"><div class="line"></div><div class="line"></div><div class="avatar"></div></div>
        <div class="product"><div class="line"></div><div class="line"></div><div class="avatar"></div></div>
    `;

    function fetchSearchResults(query, type) {
        if (!query.trim()) {
            hideResults(type);
            return;
        }

        showLoading(type);
        let baseSuggest = (window.ShopRoutes && window.ShopRoutes.searchSuggestUrl) || '/search/suggest';
        const params = new URLSearchParams({
            q: query,
            section_id: 'predictive-search',
            'resources[type]': 'product,article,page',
            'resources[options][unavailable_products]': 'hide',
            'resources[options]': 'title,url,image',
            'resources[limit]': '6',
            'resources[limit_scope]': 'each'
        });
        const currentLocale = (window.ShopLocale && window.ShopLocale.isoCode) || '';
        if (currentLocale) params.set('locale', currentLocale);
        // If Arabic locale, the localized suggest endpoint returns 417, so use unprefixed
        if (currentLocale && currentLocale.toLowerCase() === 'ar') {
            baseSuggest = '/search/suggest';
        }
        const searchURL = `${baseSuggest}?${params.toString()}`;

        function handleSuccess(data) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, "text/html");
            const resultsHTML = doc.querySelector("#shopify-section-predictive-search").innerHTML;

            const isRTL = (window.ShopLocale && window.ShopLocale.dir === 'rtl') || document.documentElement.dir === 'rtl';
            const currentLocale = (window.ShopLocale && window.ShopLocale.isoCode) || '';
            const isArabic = currentLocale && currentLocale.toLowerCase() === 'ar';

            if (!isArabic) {
                // Non-AR: inject immediately and post-process in-place
                if (type === "mobile") {
                    predictiveSearchMobile.innerHTML = resultsHTML;
                    predictiveSearchMobile.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
                    predictiveSearchMobile.classList.toggle('predictive-rtl', isRTL);
                    predictiveSearchMobile.classList.toggle('predictive-ltr', !isRTL);
                } else {
                    predictiveSearchDesktop.innerHTML = resultsHTML;
                    predictiveSearchDesktop.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
                    predictiveSearchDesktop.classList.toggle('predictive-rtl', isRTL);
                    predictiveSearchDesktop.classList.toggle('predictive-ltr', !isRTL);
                }

                try {
                    const i18n = window.PredictiveI18n || {};
                    const root = type === 'mobile' ? predictiveSearchMobile : predictiveSearchDesktop;
                    const resultsContainer = root.querySelector('#predictive-search-results');
                    if (resultsContainer) {
                        resultsContainer.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
                        resultsContainer.classList.toggle('predictive-rtl', isRTL);
                        resultsContainer.classList.toggle('predictive-ltr', !isRTL);
                    }
                    const productHeaderSpan = root.querySelector('#predictive-search-products .search-product-title');
                    if (productHeaderSpan && i18n.search_product_title) {
                        productHeaderSpan.textContent = i18n.search_product_title;
                    }
                    const articleHeaderSpan = root.querySelector('#predictive-search-articles .search-article-title');
                    if (articleHeaderSpan && i18n.search_article_title) {
                        articleHeaderSpan.textContent = i18n.search_article_title;
                    }
                    const pagesHeader = Array.from(root.querySelectorAll('h3#predictive-search-products'))
                        .find(h3 => !h3.querySelector('.search-product-title'));
                    if (pagesHeader && i18n.search_page_title) {
                        pagesHeader.textContent = i18n.search_page_title;
                    }
                    const noResult = root.querySelector('.no-result');
                    if (noResult && i18n.no_results) {
                        const termSpan = noResult.querySelector('span');
                        const termNode = termSpan ? termSpan.cloneNode(true) : null;
                        noResult.textContent = i18n.no_results + ' ';
                        if (termNode) noResult.appendChild(termNode);
                    }
                    const showAllLink = root.querySelector('.showAll a');
                    if (showAllLink && i18n.see_all_results) {
                        const icon = showAllLink.querySelector('i');
                        const term = (showAllLink.textContent.match(/"(.*)"/) || [])[1] || '';
                        showAllLink.textContent = i18n.see_all_results + (term ? ` "${term}" ` : ' ');
                        if (icon) showAllLink.appendChild(icon);
                    }
                    const rootUrl = (window.ShopRoutes && window.ShopRoutes.rootUrl) || '';
                    const localePrefix = rootUrl === '/' ? '' : rootUrl;
                    if (localePrefix) {
                        const anchors = root.querySelectorAll('#predictive-search-results a[href^="/"]');
                        anchors.forEach(a => {
                            try {
                                const href = a.getAttribute('href') || '';
                                if (!href.startsWith(localePrefix + '/')) {
                                    a.setAttribute('href', localePrefix + href);
                                }
                            } catch (_) {}
                        });
                    }
                } catch (e) {}

                showResults(type);
                return;
            }

            // AR locale: keep skeleton visible, hydrate in a temp container, then swap in
            const tempWrapper = document.createElement('div');
            tempWrapper.innerHTML = resultsHTML;

            const i18n = window.PredictiveI18n || {};
            const resultsContainerTemp = tempWrapper.querySelector('#predictive-search-results');
            if (resultsContainerTemp) {
                resultsContainerTemp.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
                resultsContainerTemp.classList.toggle('predictive-rtl', isRTL);
                resultsContainerTemp.classList.toggle('predictive-ltr', !isRTL);
            }
            // Headings localization
            const prodHeaderSpanTemp = tempWrapper.querySelector('#predictive-search-products .search-product-title');
            if (prodHeaderSpanTemp && i18n.search_product_title) prodHeaderSpanTemp.textContent = i18n.search_product_title;
            const artHeaderSpanTemp = tempWrapper.querySelector('#predictive-search-articles .search-article-title');
            if (artHeaderSpanTemp && i18n.search_article_title) artHeaderSpanTemp.textContent = i18n.search_article_title;
            const pagesHeaderTemp = Array.from(tempWrapper.querySelectorAll('h3#predictive-search-products')).find(h3 => !h3.querySelector('.search-product-title'));
            if (pagesHeaderTemp && i18n.search_page_title) pagesHeaderTemp.textContent = i18n.search_page_title;
            const noResultTemp = tempWrapper.querySelector('.no-result');
            if (noResultTemp && i18n.no_results) {
                const termSpan = noResultTemp.querySelector('span');
                const termNode = termSpan ? termSpan.cloneNode(true) : null;
                noResultTemp.textContent = i18n.no_results + ' ';
                if (termNode) noResultTemp.appendChild(termNode);
            }
            // See all results link localization
            const showAllLinkTemp = tempWrapper.querySelector('.showAll a');
            if (showAllLinkTemp && i18n.see_all_results) {
                const icon = showAllLinkTemp.querySelector('i');
                const term = (showAllLinkTemp.textContent.match(/"(.*)"/) || [])[1] || '';
                showAllLinkTemp.textContent = i18n.see_all_results + (term ? ` "${term}" ` : ' ');
                if (icon) showAllLinkTemp.appendChild(icon);
            }
            // Link prefixing
            const rootUrl = (window.ShopRoutes && window.ShopRoutes.rootUrl) || '';
            const localePrefix = rootUrl === '/' ? '' : rootUrl;
            if (localePrefix) {
                const anchors = tempWrapper.querySelectorAll('#predictive-search-results a[href^="/"]');
                anchors.forEach(a => {
                    try {
                        const href = a.getAttribute('href') || '';
                        if (!href.startsWith(localePrefix + '/')) {
                            a.setAttribute('href', localePrefix + href);
                        }
                    } catch (_) {}
                });
            }

            // Hydrate titles by fetching target pages
            const items = tempWrapper.querySelectorAll('#predictive-search-results li[role="option"] a[href]');
            const acceptLang = currentLocale;
            const promises = Array.from(items).map(a => {
                const titleSpan = a.querySelector('span');
                const href = a.getAttribute('href');
                if (!titleSpan || !href) return Promise.resolve();
                return fetch(href, { headers: { 'Accept-Language': acceptLang } })
                    .then(r => r.ok ? r.text() : null)
                    .then(html => {
                        if (!html) return;
                        const p = new DOMParser().parseFromString(html, 'text/html');
                        const og = p.querySelector('meta[property="og:title"]');
                        const ogTitle = og && og.getAttribute('content');
                        const h1 = p.querySelector('h1');
                        const docTitle = p.querySelector('title');
                        const localized = ogTitle || (h1 && h1.textContent.trim()) || (docTitle && docTitle.textContent.trim());
                        if (localized) {
                            titleSpan.textContent = localized.length > 70 ? localized.slice(0, 67) + '…' : localized;
                        }
                    })
                    .catch(() => {});
            });

            const finalize = () => {
                if (type === "mobile") {
                    predictiveSearchMobile.innerHTML = tempWrapper.innerHTML;
                    predictiveSearchMobile.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
                    predictiveSearchMobile.classList.toggle('predictive-rtl', isRTL);
                    predictiveSearchMobile.classList.toggle('predictive-ltr', !isRTL);
                } else {
                    predictiveSearchDesktop.innerHTML = tempWrapper.innerHTML;
                    predictiveSearchDesktop.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
                    predictiveSearchDesktop.classList.toggle('predictive-rtl', isRTL);
                    predictiveSearchDesktop.classList.toggle('predictive-ltr', !isRTL);
                }
                showResults(type);
            };

            let done = false;
            Promise.allSettled(promises).then(() => { if (!done) { done = true; finalize(); } });
            setTimeout(() => { if (!done) { done = true; finalize(); } }, 3000);
        }

        function attemptFetch(url, attempt = 1) {
            const fetchOptions = {};
            if (currentLocale) {
                fetchOptions.headers = { 'Accept-Language': currentLocale };
            }
            return fetch(url, fetchOptions)
                .then(response => {
                    if (!response.ok) {
                        // If Arabic (or any locale) localized endpoint fails, retry with unprefixed + locale
                        if (attempt === 1) {
                            const fallbackBase = '/search/suggest';
                            const fallbackParams = new URLSearchParams(params);
                            const locale = (window.ShopLocale && window.ShopLocale.isoCode) || '';
                            if (locale) fallbackParams.set('locale', locale);
                            const fallbackUrl = `${fallbackBase}?${fallbackParams.toString()}`;
                            return attemptFetch(fallbackUrl, 2);
                        }
                        throw new Error(response.status);
                    }
                    return response.text();
                })
                .then(data => handleSuccess(data))
                .catch(() => {
                    if (attempt >= 2) {
                        hideResults(type);
                    }
                });
        }

        attemptFetch(searchURL);
    }

    function showLoading(type) {
        const isRTL = (window.ShopLocale && window.ShopLocale.dir === 'rtl') || document.documentElement.dir === 'rtl';
        const skeleton = isRTL ? loadingSkeletonRTL : loadingSkeletonLTR;
        if (type === "mobile") {
            predictiveSearchMobile.innerHTML = skeleton;
            predictiveSearchMobile.style.display = "block";
            predictiveSearchMobile.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
            predictiveSearchMobile.classList.toggle('predictive-rtl', isRTL);
            predictiveSearchMobile.classList.toggle('predictive-ltr', !isRTL);
        } else {
            predictiveSearchDesktop.innerHTML = skeleton;
            predictiveSearchDesktop.style.display = "block";
            predictiveSearchDesktop.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
            predictiveSearchDesktop.classList.toggle('predictive-rtl', isRTL);
            predictiveSearchDesktop.classList.toggle('predictive-ltr', !isRTL);
        }
    }

    function showResults(type) {
        if (type === "mobile") {
            predictiveSearchMobile.style.display = "block";
            clearSearchMobile.style.display = "block";
        } else {
            predictiveSearchDesktop.style.display = "block";
            clearSearchDesktop.style.display = "block";
        }
    }

    function hideResults(type) {
        if (type === "mobile") {
            predictiveSearchMobile.style.display = "none";
            clearSearchMobile.style.display = "none";
            searchInputMobile.value = "";
        } else {
            predictiveSearchDesktop.style.display = "none";
            clearSearchDesktop.style.display = "none";
            searchInputDesktop.value = "";
        }
    }

    function debounce(func, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }

    if (searchInputDesktop && window.innerWidth > 769) {
        activeInput = searchInputDesktop;
        searchInputDesktop.addEventListener("input", debounce(() => fetchSearchResults(activeInput.value, "desktop"), 300));
    }

    if (searchInputMobile && window.innerWidth < 769) {
        activeInput = searchInputMobile;
        searchInputMobile.addEventListener("input", debounce(() => fetchSearchResults(activeInput.value, "mobile"), 300));
    }

    if (clearSearchDesktop && window.innerWidth > 769) {
        clearSearchDesktop.addEventListener("click", () => hideResults("desktop"));
    }

    if (clearSearchMobile && window.innerWidth < 769) {
        clearSearchMobile.addEventListener("click", () => hideResults("mobile"));
    }

    if (searchButtonDesktop) {
        searchButtonDesktop.addEventListener("click", (e) => {
            e.stopPropagation();
            searchSectionDesktop.style.display = (searchSectionDesktop.style.display === "block") ? "none" : "block";
            if (searchSectionDesktop.style.display === "block") {
                activeInput.focus();
            }
        });
    }

    if (searchButtonMobile) {
        searchButtonMobile.addEventListener("click", (e) => {
            e.stopPropagation();
            searchSectionMobile.style.display = (searchSectionMobile.style.display === "block") ? "none" : "block";
            if (searchSectionMobile.style.display === "block") {
                headerMenu.classList.remove("show-menu");
                activeInput.focus();
            }
        });
    }

    document.addEventListener("click", (e) => {
        if (searchSectionDesktop && !searchSectionDesktop.contains(e.target) && e.target !== searchButtonDesktop && window.innerWidth > 769) {
            hideResults("desktop");
            searchSectionDesktop.style.display = "none";
        }
        if (searchSectionMobile && !searchSectionMobile.contains(e.target) && e.target !== searchButtonMobile && window.innerWidth < 769) {
            hideResults("mobile");
            searchSectionMobile.style.display = "none";
        }
    });
}

PredictiveSearch();